module.exports = __webpack_public_path__ + "img/chart-light.30b6ac1.svg";